import millify from "millify";
import { Box, Typography } from "@mui/material";

interface Props {
  value: number;
  name: string;
  displayPercent?: boolean;
}

export function PersonalizedQuotesListCardDetailsElement({
  value,
  name,
  displayPercent,
}: Props) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        [theme.breakpoints.up("sm")]: {
          flexDirection: "column",
        },
      })}>
      <Typography
        sx={{
          fontSize: 16,
        }}>
        {displayPercent ? `${value}%` : `$${millify(value, { precision: 0 })}`}
      </Typography>
      <Typography variant="subtitle1">{name}</Typography>
    </Box>
  );
}
